module.exports = __webpack_public_path__ + "static/media/04.fe5ef627.jpg";